// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../core/button';
import Error from '../core/error';
import Form from '../core/form';
import Input from '../core/input';
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import RecordDetails from '../core/record-details';
import SubmitButton from '../core/submit-button';
import Thumbnail from '../core/thumbnail';
import Uploader from './uploader';

// Containers
import FormData from '../../containers/form-data';

// Styles
import './edit-network-image.scss';

const formName = 'editNetworkImage';

function EditNetworkImage({ whitelistKeys = ['imageId', 'dateCreated', 'lastUpdated', 'rawResourceUri', 'finalResourceName']}) {
  const handleResetClick = (event, resetForm) => {
    event && event.preventDefault && event.preventDefault();

    resetForm();
  };

  const getFormProps = ({ searchValues: { guid } = {} }) => ({
    name: formName,
    className: 'edit-network-image',
    fixedPositionedResponse: true,
    resetOnSubmit: false,
    submitData: !!guid,
  });

  const handleUploaderChange = (imageUrl, imageName, { setFieldValue }) => {
    setFieldValue('image', {
      category: 'NETWORK_LOGO',
      finalResourceName: imageUrl || '',
      mimeType: 'image/jpeg',
      primary: false,
      rawResourceUri: imageName || '',
      state: 'UPLOADED_REMOTE',
      version: 0,
    });
  };

  const renderCurrentImage = (image) => (image ? (
            <>
                <Thumbnail src={image.finalResourceName} />
                <RecordDetails
                    className="edit-network-image--record"
                    searchData={[image]}
                    whitelistKeys={whitelistKeys}
                />
            </>
        ) : (
            <div className="edit-network-image--message">No current network logo image</div>
        ));

  return (
        <Permissions
            accessRequirement="update"
            elementService="network"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            <FormData formName={formName}>
                {(formData) => {
                  const { resetForm, searchFetching, searchValues: { image = {}, networkId } = {} } = formData;

                  return (
                        <>
                            {networkId ? (
                                <Form {...getFormProps(formData)}>
                                    <div className="edit-network-image--current-image">
                                        <label className="edit-network-image--label">Current Image:</label>
                                        {renderCurrentImage(image)}
                                    </div>
                                    <div className="edit-network-image--new-image">
                                        <label className="edit-network-image--label">New Image:</label>
                                        <Uploader
                                            onChange={(imageUrl, imageName) => handleUploaderChange(imageUrl, imageName, formData)}
                                        />
                                        <Input
                                            className="edit-network-image--input"
                                            label="Image URL"
                                            name="image.finalResourceName"
                                            validate={['required', 'imageUrlJpg']}
                                            onChange={(e) => { formData.setFieldValue('status', e.target.value); }}
                                        />
                                    </div>

                                    <div className="edit-network-image--controls">
                                        <SubmitButton label="Save" />
                                        <Button
                                            className="edit-network-image--reset-button"
                                            onClick={(event) => handleResetClick(event, resetForm)}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </Form>
                            ) : (
                                <Error
                                    className="edit-network-image--message"
                                    error="Select a network from the list."
                                />
                            )}
                            <Loading loading={searchFetching} />
                        </>
                  );
                }}
            </FormData>
        </Permissions>
  );
}

EditNetworkImage.propTypes = {
    whitelistKeys: PropTypes.array,
};

export default EditNetworkImage;
